import { render, staticRenderFns } from "./EditNutrientEfficiency.vue?vue&type=template&id=6df168c3&"
import script from "./EditNutrientEfficiency.vue?vue&type=script&lang=js&"
export * from "./EditNutrientEfficiency.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports